import { ApiError, Duel } from "./api";
import { Board, generateRandomBoard } from "./board";

export enum GameStateMarker {
  NotStarted = 1,
  InProgress,
  Finished,

  Loading,
  DuelChallenge1,
  DuelChallenge2,

  DuelResults,
}

export interface GameStateNotStarted {
  marker: GameStateMarker.NotStarted;
  board: Board;
  duelNotFound: boolean;
  startingDuel: boolean;
  error?: ApiError;
}

export interface GameStateInProgress {
  marker: GameStateMarker.InProgress;
  board: Board;
  userWordList: [string, number][];
  userWordSet: Set<string>;
  isPaused: boolean;
  duel: Duel | null;
  duelNickname: string;
}

export interface GameStateFinished {
  marker: GameStateMarker.Finished;
  board: Board;
  score: number;
  maxScore: number;
  userWordList: [string, number][];
  missedWords: string[];
  duel: Duel | null;
  duelNickname: string;
  error?: ApiError;
}

export interface GameStateLoading {
  marker: GameStateMarker.Loading;
}

export interface GameStateDuelChallenge1 {
  marker: GameStateMarker.DuelChallenge1;
  duel: Duel;
}

export interface GameStateDuelChallenge2 {
  marker: GameStateMarker.DuelChallenge2;
  duel: Duel;
  nickname: string;
}

export interface GameStateDuelResults {
  marker: GameStateMarker.DuelResults;
  duel: Duel;
}

export type GameState =
  | GameStateNotStarted
  | GameStateInProgress
  | GameStateFinished
  | GameStateLoading
  | GameStateDuelChallenge1
  | GameStateDuelChallenge2
  | GameStateDuelResults;

export function initialState(): GameState {
  return {
    marker: GameStateMarker.NotStarted,
    board: generateRandomBoard(),
    startingDuel: false,
    duelNotFound: false,
  };
}

export const GAME: { state: GameState } = {
  state: initialState()
};
